export const companyConstants = {
  COMPANY_CREATION_REQUEST: 'COMPANY_CREATION_REQUEST',
  COMPANY_CREATION_SUCCESS: 'COMPANY_CREATION_SUCCESS',
  COMPANY_CREATION_FAILURE: 'COMPANY_CREATION_FAILURE',

  COMPANY_NOT_FINISHED_REMOVAL_REQUEST: 'COMPANY_NOT_FINISHED_REMOVAL_REQUEST',
  COMPANY_NOT_FINISHED_REMOVAL_SUCCESS: 'COMPANY_NOT_FINISHED_REMOVAL_SUCCESS',
  COMPANY_NOT_FINISHED_REMOVAL_FAILURE: 'COMPANY_NOT_FINISHED_REMOVAL_FAILURE'
}